import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { makeStyles, shorthands, Button, Subtitle1, Title1 } from '@fluentui/react-components';
import { SignOutRegular } from "@fluentui/react-icons";

import { useSignInState } from './Components/signInState';
import { useHandleLogout } from './Components/HandleLogout';

import RegisterCustomer from './Components/RegisterCustomer';

import backgroundImage from './Assets/backgrounds/basecamphero.png';
import logo from './Assets/Logos/logo-white.svg';

const useStyles = makeStyles({
    container: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        ...shorthands.gap('1rem'),
        ...shorthands.padding('2rem'),
        boxSizing: 'border-box',
        // maxWidth: '800px',
        // minWidth: '370px',
        ...shorthands.margin('auto'),
    },
    pageWrapper: {
        boxSizing: 'border-box',
        padding: '8px',
        backgroundColor: '#ECECEC',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        position: 'relative', // Allows absolutely positioned children (shade, logo)
    },
    shade: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 1, // Behind the card and logo
    },
    logoWrapper: {
        position: 'absolute',
        top: '30px',
        left: '30px',
        zIndex: 3, // Above the shade and card
        width: '150px', // Adjust as needed
        height: 'auto',
    },
    logoImage: {
        width: '150px', // adjust as needed
        height: 'auto',
    },
    loginCard: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '12px',
        padding: '50px',
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        margin: '0 auto',
        width: '100%',
        maxWidth: '600px',
        zIndex: 2,
        position: 'relative',
        boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.2)',
    },
    heading: {
        textAlign: 'center',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    // other styles...
});

const SignUpFlow = () => {
    const { accounts } = useMsal();
    const { signInState } = useSignInState();
    const [isPending, setIsPending] = useState(true);
    const { handleLogout } = useHandleLogout();
    const styles = useStyles();

    if (signInState.hasAccount && signInState.customerInfo.length === 0) {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.shade}></div>
                {/* Logo is now a sibling of pageWrapperInner and absolutely positioned */}
                <div className={styles.logoWrapper}>
                    <img className={styles.logoImage} src={logo} alt="Basecamp Logo" />
                </div>
                <div className={styles.loginCard} >
                    <div className={styles.heading}>
                        <Title1>There are no active customer accounts assigned to your user</Title1><p/> 
                        <Subtitle1>Speak to the administrator for the company you are trying to access for an invite.</Subtitle1><p/> 
                        <Button appearance='primary' size="medium" icon={<SignOutRegular />} onClick={handleLogout} >
                            Logout
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    if (signInState.hasAccount) {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.shade}></div>
                {/* Logo is now a sibling of pageWrapperInner and absolutely positioned */}
                <div className={styles.logoWrapper}>
                    <img className={styles.logoImage} src={logo} alt="Basecamp Logo" />
                </div>
                <div className={styles.loginCard} >
                    <div className={styles.heading}>
                        <Title1>User Account is Inactive</Title1><p/> 
                        <Button appearance='primary' size="medium" icon={<SignOutRegular />} onClick={handleLogout} >
                            Logout
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    if (!signInState.hasAccount && signInState.customerInfo.length > 0) {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.shade}></div>
                {/* Logo is now a sibling of pageWrapperInner and absolutely positioned */}
                <div className={styles.logoWrapper}>
                    <img className={styles.logoImage} src={logo} alt="Basecamp Logo" />
                </div>
                <div className={styles.loginCard} >
                    <div className={styles.heading}>
                        <Title1>No user account found</Title1><p/> 
                        <Subtitle1>Speak to the administrator for the company you are trying to access for an invite.</Subtitle1><p/> 
                        <Button appearance='primary' size="medium" icon={<SignOutRegular />} onClick={handleLogout} >
                            Logout
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    if (signInState.customerInfo.length == 0) {
        return (
            <RegisterCustomer />
        )
    }

    console.log('signInState.customerInfo length:', signInState.customerInfo.length);
    if (signInState.customerInfo.length > 0 && !signInState.customerInfo.some(company => company.IsActive)) {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.shade}></div>
                {/* Logo is now a sibling of pageWrapperInner and absolutely positioned */}
                <div className={styles.logoWrapper}>
                    <img className={styles.logoImage} src={logo} alt="Basecamp Logo" />
                </div>
                <div className={styles.loginCard} >
                    <div className={styles.heading}>
                        <Title1>Customer Account is Inactive</Title1>
                        {/* Redirect to buying a license again   */}
                    </div>
                </div>
            </div>
        )
    }

    return null;
};

export default SignUpFlow;